<template>
    <section class="flex client_logo p-0 -mb-[60px] relative z-2">
        <div class="clients_wrapper container">
            <div class="row items-center justify-center text-center">
                <div class="col-md-12">
                    <div class="p-5 bg-white border border-gray-200 partner_logo shadow rounded-xl">
                        <div class="grid grid-cols-2 md:grid-cols-6">
                            <div v-for="(logo, index) in logos" :key="index" class="col-lg-2 col-md-4 col-6">
                                <div
                                    class="px-3 py-2 md:px-2 flex items-center justify-center"
                                >
                                    <img class="w-[140px] h-[50px] object-contain"
                                        :src="logo"
                                        :alt="'client_logo_' + (index + 1)"
                                        :title="'client_logo_' + (index + 1)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import rostex_img from '@img/partners/rostex.png'
import serverstal_img from '@img/partners/serverstal.png'
import vodokanal_img from '@img/partners/vodokanal.png'
import vnukovo_img from '@img/partners/vnukovo.png'
import x5_img from '@img/partners/x5.png'
import renessans_img from '@img/partners/renessans.png'

export default {
    name: "FooterMapPartners",
    data() {
        return {
            logos: [
                rostex_img,
                serverstal_img,
                vodokanal_img,
                vnukovo_img,
                x5_img,
                renessans_img,
            ],
        };
    },
};
</script>

<style scoped>
img {
    filter: invert(50%);
    height: 50px;
    -o-object-fit: contain;
    object-fit: contain;
    width: auto;
}

.z-2 {
    z-index: 2;
}
</style>
